<form
  class="connect-bg connect-channel"
  (ngSubmit)="addWhatsappPlayground()"
  [formGroup]="phoneForm"
  name="whatsappPlaygroundForm"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <h2>{{ titleText }}</h2>
  <p [innerHTML]="descriptionText"></p>
  <p>
    {{ whitelistInfoText }}
  </p>
  <p
    ><strong>{{ whitelistTitleText }}</strong></p
  >
  <ngx-mat-intl-tel-input
    [preferredCountries]="['es', 'us', 'gb']"
    [enablePlaceholder]="true"
    [enableSearch]="true"
    required
    name="phone"
    formControlName="phone"
    #phone
  ></ngx-mat-intl-tel-input>
  <mat-hint
    >{{ exampleHintText }} {{ phone.selectedCountry.placeHolder }}</mat-hint
  >

  <button
    mat-raised-button
    fxFlex="none"
    type="submit"
    [disabled]="!phoneForm.valid"
  >
    {{ connectButtonText }}
  </button>
  <p [innerHTML]="noteText"></p>
</form>
